// 1. import `extendTheme` function
import { extendTheme } from "@chakra-ui/react";
import "@fontsource/source-sans-pro";
import { createBreakpoints } from "@chakra-ui/theme-tools";

//md mac , lg benq
const breakpoints = createBreakpoints({
  // sm: "30em",
  md: "0px",
  lg: "2040px",
  // xl: "80em",
  // "2xl": "96em",
});
// 2. Add your color mode config
const config = {
  fonts: {
    body: "Source Sans Pro",
    heading: "Source Sans Pro",
  },
};

// Component overrides. The software default keeps Chakra's rounded buttons and
// input borders, so these apply only when their param is set.
//
// ?button_style=square squares the buttons (Chakra default radius is "md" =
// 0.375rem). ?theme=light gives the inputs a flat #cccccc border and a #718096
// placeholder. The two are independent, so either can be set on its own. Inputs
// keep the default 0.375rem radius; only buttons follow button_style.
const squareButton = {
  Button: { baseStyle: { borderRadius: "none" } },
};

const lightInputs = {
  Input: {
    baseStyle: {
      field: { borderColor: "#cccccc", _placeholder: { color: "#718096" } },
    },
  },
  Select: {
    baseStyle: { field: { borderColor: "#cccccc" } },
  },
};

// 3. extend the theme. Pass { light, square } to add the matching overrides.
export const getTheme = ({ light = false, square = false } = {}) => {
  const components = {
    ...(square ? squareButton : {}),
    ...(light ? lightInputs : {}),
  };
  return extendTheme({
    config,
    breakpoints,
    ...(Object.keys(components).length ? { components } : {}),
  });
};

const theme = getTheme();

export default theme;
